import { cn } from "@/lib/utils";

interface ListeningIconProps {
  className?: string;
}

export const ListeningIcon = ({ className }: ListeningIconProps) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-1 w-4 h-4",
        className
      )}
    >
      <span
        className="w-1 h-2 bg-current rounded-full animate-sound-wave"
        style={{ animationDelay: "0s" }}
      />
      <span
        className="w-1 h-2 bg-current rounded-full animate-sound-wave"
        style={{ animationDelay: "0.2s" }}
      />
      <span
        className="w-1 h-2 bg-current rounded-full animate-sound-wave"
        style={{ animationDelay: "0.4s" }}
      />
    </div>
  );
};
